<div class="main_page">
  <div class="col home_page">
    @if (search_button_clicked) {
    <div class="top-search-container">
      <app-search (is_search_clicked)="clicked_search($event)"></app-search>
    </div>
    }@else {
    <div class="hero h-screen">
      <img src="../../../assets/icons/AdobeStock_425579329.jpeg" />
      <div class="content h-screen">
        <div class="header">What are you looking for?</div>
        <div class="sub-header">Video editing made easy</div>
        <div class="top-search-container">
          <app-search (is_search_clicked)="clicked_search($event)"></app-search>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- @if ( commonservice.video_data && commonservice.video_data.length != 0 ){
  <div class="col">
    <div class="asset_names">
      <h3>Available Assets</h3>
      <ol class="chip_container">
        @for (item of get_data(commonservice.video_data) | keyvalue ; track
        $index) {
        <p-chip
          class="cursor-pointer"
          label="{{ item.key }}"
          (click)="activeIndexChange($index)"
        ></p-chip>
        }
      </ol>
    </div>
    <div class="grid">
      <div class="col md:col-12 lg:col-12">
        <p-accordion
          [multiple]="true"
          (activeIndexChange)="activeIndexChange($event)"
          [activeIndex]="[activeIndex ?? 0]"
        >
          @for (item of get_data(commonservice.video_data) | keyvalue ; track
          $index) {
          <p-accordionTab header="{{ item.key }}">
            <ng-template pTemplate="header">
              <span class="flex align-items-center gap-2 w-auto">
                <p-badge value="{{ item.value.length }}" class="ml-auto" />
              </span>
            </ng-template>
            <div class="small_video_players">
              <div *ngFor="let item of items[item.key]">
                <div id="{{ $index }}" class="col">
                  <app-video-player
                    [videoUrl]="item"
                    [required_controls]="false"
                    id="video_{{ $index }}"
                  ></app-video-player>
                </div>
              </div>
             
            </div>
          </p-accordionTab>
          }
        </p-accordion>
      </div>
    </div>
  </div>
  } @else if(search_button_clicked && (commonservice.video_data &&
  commonservice.video_data.length == 0)){
  <h2>No Assets Found. Please refine your search</h2>
  } -->
</div>
